import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";
import DiabetesImage from "../../images/leistungen/diabetes.jpg"

const Diabetes = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Diabetes im Griff </h1>
                    <img src={DiabetesImage} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Therapie aktiv ist ein Langzeitbetreuungsprogramm durch das sie den Diabetes noch besser in der Griff bekommen können. Gemeinsam (PatientIn und Arzt) sind wir AKTIV, um die gefürchteten Folgeerkrankungen zu vermeiden bzw. hinauszuzögern.
                        <br /> <br /> Wir führen auch Schulungen durch, bei welchen Ihnen die Grundlagen des Diabetes und die Lebensstilmassnahmen (was ist Zucker, was darf ich essen, was lieber nicht....etc.) näher gebracht werden sollen.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Diabetes;
